<p-toast/>

<section class="space-y-6">
  <div>
    <h1 class="text-2xl font-bold mb-6">Nueva oferta</h1>
    <p-card class="shadow rounded-xl w-full">
      <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-6">

        <div>
          <h2 class="text-lg font-medium mb-2">Cliente</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label for="nombreCliente" class="block mb-1 text-sm font-medium">Cliente</label>
              <input pInputText id="nombreCliente" formControlName="nombreCliente" class="w-full"/>
            </div>
            <div>
              <label for="cups" class="block mb-1 text-sm font-medium">CUPS</label>
              <input pInputText id="cups" formControlName="cups" class="w-full"/>
            </div>
            <div>
              <label for="companiaActual" class="block mb-1 text-sm font-medium">Compañía</label>
              <input pInputText id="companiaActual" formControlName="companiaActual" class="w-full"/>
            </div>
          </div>

          <div class="grid grid-cols-2 md:grid-cols-2 gap-4 mt-4">
            <div>
              <label for="tipoTarifa" class="block mb-1 text-sm font-medium">Tipo tarifa</label>
              <p-dropdown id="tipoTarifa" formControlName="tipoTarifa" [options]="tarifas" class="w-full"></p-dropdown>
            </div>
            <div>
              <label for="diasFactura" class="block mb-1 text-sm font-medium">Días factura</label>
              <p-inputNumber id="diasFactura" formControlName="diasFactura" [min]="1" [max]="90"
                             class="w-full"></p-inputNumber>
            </div>
          </div>
        </div>

        <div>
          <h2 class="text-lg font-medium mb-2">Potencias</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block mb-1 text-sm font-medium">Potencia P1</label>
              <p-inputNumber formControlName="potenciaP1" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="6"
                             locale="es-ES" class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Potencia P2</label>
              <p-inputNumber formControlName="potenciaP2" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="6"
                             locale="es-ES" class="w-full"></p-inputNumber>
            </div>
          </div>
        </div>

        <div>
          <h2 class="text-lg font-medium mb-2">Consumos</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label for="consumoP1" class="block mb-1 text-sm font-medium">Consumo P1 (kWh)</label>
              <p-inputNumber id="consumoP1" formControlName="consumoP1" mode="decimal" [minFractionDigits]="0"
                             [maxFractionDigits]="6" locale="es-ES" class="w-full"></p-inputNumber>
            </div>
            <div>
              <label for="consumoP2" class="block mb-1 text-sm font-medium">Consumo P2 (kWh)</label>
              <p-inputNumber id="consumoP2" formControlName="consumoP2" mode="decimal" [minFractionDigits]="0"
                             [maxFractionDigits]="6" locale="es-ES" class="w-full"></p-inputNumber>
            </div>
            <div>
              <label for="consumoP3" class="block mb-1 text-sm font-medium">Consumo P3 (kWh)</label>
              <p-inputNumber id="consumoP3" formControlName="consumoP3" mode="decimal" [minFractionDigits]="0"
                             [maxFractionDigits]="6" locale="es-ES" class="w-full"></p-inputNumber>
            </div>
          </div>
        </div>

        <div>
          <h2 class="text-lg font-medium mb-2">Precios</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label class="block mb-1 text-sm font-medium">Precio consumido P1 (€)</label>
              <p-inputNumber formControlName="precioConsumidoP1" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Precio consumido P2 (€)</label>
              <p-inputNumber formControlName="precioConsumidoP2" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Precio consumido P3 (€)</label>
              <p-inputNumber formControlName="precioConsumidoP3" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Total consumo (€)</label>
              <p-inputNumber formControlName="precioTotalConsumido" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full" [readonly]="true"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Total potencia (€)</label>
              <p-inputNumber formControlName="precioTotalPotencia" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
          </div>
        </div>

        <div>
          <h2 class="text-lg font-medium mb-2">Impuestos y otros</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block mb-1 text-sm font-medium">Otros costes (€)</label>
              <p-inputNumber formControlName="otrosCostes" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Bono social (€)</label>
              <p-inputNumber formControlName="bonoSocial" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Regularización Financiación BS</label>
              <p-inputNumber formControlName="regularizacionFinanciacionBs" mode="currency" currency="EUR"
                             locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">RD 10/2022 Tope del gas</label>
              <p-inputNumber formControlName="rdTopeGas" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Descuento</label>
              <p-inputNumber formControlName="descuento" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Impuesto de Electricidad</label>
              <p-inputNumber formControlName="impuestoElectricidad" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">Alquiler de equipos</label>
              <p-inputNumber formControlName="alquilerDeEquipos" mode="currency" currency="EUR" locale="es-ES"
                             class="w-full"></p-inputNumber>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium">IVA (%)</label>
              <p-inputNumber formControlName="iva" [min]="0" [max]="21" class="w-full"></p-inputNumber>
            </div>
          </div>
        </div>

        <div class="flex justify-end gap-3">
          <p-button label="Crear" icon="pi pi-check" type="submit" [loading]="loading"></p-button>
        </div>
      </form>
    </p-card>
  </div>
</section>
